<template>
  <el-dialog
    :visible.sync="showDialog"
    :show-close="false"
    custom-class="dialog-clear-style"
    width="375px"
    append-to-body
    @close="showDialog = false"
  >
    <div class="dialog-wrap">
      <div class="list-title">
        <span>最近來訪</span>
        <fps-icon class="pointer" type="close" size="24" color="#7a7a7a" @click.native="showDialog = false" />
      </div>
      <div class="list-title-2">最近30天的訪客</div>
      <div v-if="list.length || loading" class="visitor-list-wrap">
        <div
          v-for="(f, i) in list"
          :key="'visitor-' + i"
          class="one-wrap"
          :class="[!btnHover && 'can-hover', showNewUser && f.reddot === 'Display' && 'new-info']"
          @click="openChat(f.visitorUuid)"
        >
          <fps-avatar
            class="user-avatar"
            :src="f.avatarUrl"
          />
          <div class="info-wrap">
            <div class="info-top">
              <span class="user-name">{{ f.nickname }}</span>
              <div
                class="userlevel-tag"
                v-if="f.userLevel"
                :class="`level-${f.userLevel}`"
              ></div>
              <div v-if="f.newPlayerCouponLabel && userInfo.userKind === 'Player'" class="has-coupon">券</div>
              <div v-if="f.newPlayerLabel && userInfo.userKind === 'Player'" class="has-new">新人</div>
            </div>
            <div class="visit-time">{{ f.updateTime | stringifyTime }} 第{{ f.visitCount }}次訪問</div>
            <div v-if="f.visitSkillRecord" class="visit-game">{{ f.visitSkillRecord }}</div>
          </div>
        </div>
        <i v-if="loading" class="el-icon-loading"></i>
      </div>
      <div v-else class="no-data-wrap">
        <div class="img-wrap"></div>
        <span>你還沒有訪客喔</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { clearRedCircle } from '@/api'

export default {
  filters: {
    stringifyTime(time) {
      const d = new Date(time)
      const now = new Date()
      const day = parseInt(now.getTime() / (24 * 60 * 60 * 1000)) - parseInt(d.getTime() / (24 * 60 * 60 * 1000))
      if (day) {
        return `${day > 30 ? 30 : day}天前`
      } else {
        return `${d.getHours()}:${d.getMinutes()}`
      }
    }
  },
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    show: Boolean,
  },
  data() {
    return {
      showDialog: false,
      loading: false,
      list: [],
      total: 0,
      btnHover: false,
      showNewUser: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch: {
    show(show) {
      this.showDialog = show
      this.getDefaultList()
    },
    showDialog(show) {
      this.$emit('change', show)
    },
  },
  created() {
    this.showDialog = this.show
    this.getDefaultList()
  },
  methods: {
    openChat(uuid) {
      this.$util.openChatWindow(this.userInfo.uuid, uuid)
    },
    jumpDetail(uuid) {
      this.$router.push({
        path: '/player-detail/' + uuid
      })
    },
    getDefaultList() {
      if (this.show && !this.loading) {
        this.loading = true
        this.list = []
        this.getList().then((list) => {
          clearRedCircle({
            field: 'visitedTimes'
          }).then(() => {
            this.$store.dispatch('app/setRedCircle', { visitedTimes: false })
          })
          this.total = list.length
          this.loading = false
          this.showNewUser = true
          this.$nextTick(() => {
            setTimeout(() => {
              this.showNewUser = false
            }, 3000)
          })
        })
      }
    },
    getList() {
      return this.$http.get('/user/visitor').then(({ data }) => {
        this.list = data
        return data
      })
    },
  }
}
</script>
<style lang="scss" scoped>
  .dialog-wrap {
    width: 375px;
    margin: 0 auto;
    border-radius: 15px !important;
    background: #fff;
    .list-title {
      width: 100%;
      height: 60px;
      border-bottom: $color-button;
      @include flex(space-between);
      padding: 0 18px;
      font-weight: 500;
      font-size: 18px;
      line-height: 25px;
      color: $color-gray-1;
    }
    .list-title-2 {
      padding: 16px 18px;
      font-size: 14px;
      line-height: 20px;
      text-align: left;
      color: $color-gray-2;
    }
    .loading-wrap {
      height: 420px;
      @include flex;
      font-size: 28px;
    }
    .list-wrap {
      padding: 16px 20px;
      max-height: 440px;
      overflow-y: auto;
      @include hideScrollBar(0, 0, 0);
      text-align: center;
      font-size: 24px;
      .one-wrap {
        height: 90px;
        @include flex;
        padding: 0 8px;
        border-radius: 8px;
        cursor: pointer;
        &.can-hover:hover {
          background: $color-split;
        }
        .user-avatar {
          width: 58px;
          height: 58px;
        }
        .user-name {
          flex-grow: 0;
          margin: 0 2px 0 20px;
          @include ellipsis;
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
          text-align: left;
          color: $color-gray-1;
        }
        .reace-btn {
          width: 80px;
          height: 32px;
          border-radius: 16px;
          border: 1px solid $color-split;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 13px;
          line-height: 18px;
          letter-spacing: -0.000319808px;
          color: $color-gray-2;
          &:hover {
            background: rgba(232, 234, 238, 0.3);
          }
        }
        .can-follow {
          border-color: #007AFF;
          color: $color-link;
          &:hover {
            background: rgba(0, 122, 255, 0.1);
          }
        }
      }
    }
    .visitor-list-wrap {
      padding: 16px 20px;
      max-height: 440px;
      overflow-y: auto;
      @include hideScrollBar(0, 0, 0);
      text-align: center;
      font-size: 24px;
      .one-wrap {
        height: 90px;
        @include flex(flex-start, center);
        padding: 0 8px;
        border-radius: 8px;
        cursor: pointer;
        text-align: left;
        &.can-hover:hover {
          background: $color-split;
        }
        &.new-info {
          background: #FFFADF;
        }
        .user-avatar {
          flex-shrink: 0;
          width: 58px;
          height: 58px;
        }
        .info-wrap {
          width: calc(100% - 78px);
          height: 100%;
          margin-left: 20px;
        }
        .info-top {
          @include flex(flex-start);
          margin-top: 12px;
          .has-coupon {
            padding: 3px;
            font-weight: 500;
            font-size: 10px;
            line-height: 1;
            color: #FFFFFF;
            background: #FF8973;
            border-radius: 2px;
            margin-left: 4px;
          }
          .has-new {
            padding: 3px;
            font-weight: 500;
            font-size: 10px;
            line-height: 1;
            color: #FFFFFF;
            background: #1DBD80;
            border-radius: 2px;
            margin-left: 4px;
          }
        }
        .visit-time, .visit-game {
          font-size: 13px;
          line-height: 21px;
          color: $color-gray-3;
          margin-top: 3px;
          @include ellipsis;
        }
        .user-name {
          @include ellipsis;
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
          text-align: left;
          color: $color-gray-1;
        }
        .reace-btn {
          width: 80px;
          height: 32px;
          border-radius: 16px;
          border: 1px solid $color-split;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 13px;
          line-height: 18px;
          letter-spacing: -0.000319808px;
          color: $color-gray-2;
          &:hover {
            background: rgba(232, 234, 238, 0.3);
          }
        }
        .can-follow {
          border-color: $color-link;
          color: $color-link;
          &:hover {
            background: rgba(0, 122, 255, 0.1);
          }
        }
      }
    }
    .no-data-wrap {
      @include flex(center, center, column);
      height: 478px;
      .img-wrap {
        width: 108px;
        height: 90px;
        background: url('~@/assets/image/background/empty-search.png') no-repeat center center / 100%;
        margin-bottom: 12px;
      }
      span {
        font-size: 14px;
        line-height: 21px;
        text-align: center;

        color: $color-gray-3;
      }
    }
  }
  .left-wrap {
    display: flex;
    align-items: center;
  }
</style>
